import React, { useEffect, useState } from "react";
import 'animate.css';
import { Button, Card, Col, Container, FloatingLabel, Form, FormControl, FormSelect, Modal, ModalBody, Row, Spinner, Table } from "react-bootstrap";
import AnlageUseStage from "../../components/anlage/new_anlage/AnlageUseStage";
import AnlageDataStage from "../../components/anlage/new_anlage/AnlageDataStage";
import QuestionRegisterStage from "../../components/anlage/new_anlage/QuestionRegisterStage";
import RegisterStage from "../../components/anlage/new_anlage/RegisterStage";
import SummaryStage from "../../components/anlage/new_anlage/SummaryStage";
import { useAuthState } from "../../context/AuthContext";
import Validator from "../../services/Validator";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { MdAttachFile } from "react-icons/md";
import PrivateApi from "../../services/PrivateApiService";
import { FaCheck } from "react-icons/fa";
import { HiXMark } from "react-icons/hi2";
import { TbConfetti } from "react-icons/tb";
import { useLocation } from "react-router-dom";
import ContactPersonModal from "./ContactPersonModal";
import EnergoTooltip from "../../components/shared/Tooltip";


const NewBuildingPage = () => {

    const { user, contactPerson, tooltips, tooltipsTrigger } = useAuthState();
    const API = new PrivateApi();
    const VALIDATOR = new Validator();
    const [stage, setStage] = useState({
        name: { inView: true, done: false },
        address: { inView: false, done: false },
        abrechnung: { inView: false, done: false },
        anlagen: { inView: false, done: false },
        done: { inView: false, done: false }
    });
    const [anlageStage, setAnlageStage] = useState("default");
    const [data, setData] = useState({
        building_name: "",
        building_ident: "",
        vorgang: "Erstbezugsobjekt",
        oldHw: "",
        country: "12",
        state: user.state_id[0],
        building_street: "",
        building_houseNumber: "",
        zip: "",
        city: "",
        uid: "",
        noUid: false,
        building_cardHolder: "",
        building_iban: "",
        poolStarts: "",
        noVollmacht: false,
        vollmacht: {},
        hwContact: contactPerson,
        anlagen: [],

        street: "",
        houseNumber: "",
        anlageUse: "",
        anlageUseDesc: "",
        staircase: "",
        top: "",
        bestand: "",
        energyForm: "",
        smartmeter: true,
        secondZaehler: false,
        zaehlerNumber1: "",
        zaehlerNumber2: "",
        zaehlerLocation: "",
        register: false,
        asLeerstand: false,
        registerDate: "",
        zaehlerstand1: "",
        zaehlerstand2: "",
        useMtu: false,
        mtuName: "",
        mtuDirect: false,
        cardHolder: "",
        iban: "",
        mtuPaysOverTransfer: false,
    });
    const [fieldErrors, setFieldsError] = useState({});
    const [showAnlageAddForm, setShowAnlageAddForm] = useState(false);
    const [sendingData, setSendingData] = useState(false);

    const dateLimit = new Date();
    dateLimit.setDate(dateLimit.getDate() + 14);
    const location = useLocation();

    const [contactPersonModal, setContactPersonModal] = useState(false);


    useEffect(() => {
        // Add a fake history event so that the back button does nothing if pressed once
        window.history.pushState('fake-route', document.title, window.location.href);
      
        const closeQuickView = () => {
            const confirmClose = window.confirm("Wollen Sie den Vorgang tatsächlich beenden? Wenn Sie nur einen Schritt zurück wollen, drücken Sie 'Abbrechen' und verwenden Sie den orangen Zurück-Button.");
                if (confirmClose) {
                window.history.back();
                }
        };
      
        window.addEventListener('popstate', closeQuickView);
      
        // Here is the cleanup when this component unmounts
        return () => {
          window.removeEventListener('popstate', closeQuickView);
          // If we left without using the back button, aka by using a button on the page, we need to clear out that fake history event
          if (window.history.state === 'fake-route') {
            window.history.back();
          }
        };
      }, []);


    const nextBtnHandler = (stageName) => {
        if (stageName !== undefined) {
            setStage(prevStage => {
                const updatedStage = { ...prevStage };
                // Set all stages' inView properties to false
                Object.keys(updatedStage).forEach(key => {
                    updatedStage[key].inView = false;
                });
                // Set the desired stage's inView property to true
                updatedStage[stageName].inView = true;
                return updatedStage;
            });
        }

        var nextStage = "";
        var temp = {};

        if (stage.name.inView) {
            nextStage = "address";
            if (data.building_name.length < 3) temp.building_name = true;
            if (data.building_ident === "") temp.building_ident = true;
            if (data.vorgang === "") temp.vorgang = true;
            if (data.vorgang === "Hausverwaltungswechsel" && data.oldHw.length < 4) temp.oldHw = true;
        }
        if (stage.address.inView) {
            nextStage = "abrechnung";
            if (data.country === "") temp.country = true;
            if (data.state === "") temp.state = true;
            if (data.building_street.length < 4) temp.building_street = true;
            if (data.building_houseNumber === "") temp.building_houseNumber = true;
            if ((data.country === "12" && data.zip.length !== 4) || (data.country === "57" && data.zip.length !== 5) || !VALIDATOR.IsNumeric(data.zip)) temp.zip = true;
            if (data.city.length < 4) temp.city = true;
        }
        if (stage.abrechnung.inView) {
            nextStage = "anlagen";
            if (data.noUid === false && !VALIDATOR.vatValid(data.uid)) temp.uid = true;
            if (data.noUid === true) setData((prev) => ({ ...prev, uid: "" }));
            if (data.building_cardHolder.length < 4) temp.building_cardHolder = true;
            if (!VALIDATOR.ibanValid(data.building_iban.replace(/\s+/g, ''))) temp.building_iban = true;
            if (data.poolStarts === "") temp.poolStarts = true;
            if (contactPerson === null || contactPerson === undefined) temp.hwContact = true;
            if (data.noVollmacht === false && (data.vollmacht.file === undefined || data.vollmacht.file === "")) temp.vollmacht = true;
            setData((prev) => ({...prev, hwContact: contactPerson}));
        }
        if (stage.anlagen.inView && stageName === undefined) {
            nextStage = "done";
        }

        if (Object.keys(temp).length > 0) {
            return setFieldsError(temp);
        }

        setStage(prevStage => {
            const updatedStage = { ...prevStage };
            // Set all stages' inView properties to false
            Object.keys(updatedStage).forEach(key => {
                updatedStage[key].inView = false;
            });
            // Set the desired stage's inView property to true
            updatedStage[nextStage].inView = true;
            return updatedStage;
        });
    }

    const backBtnHandler = (nextStage) => {
        setStage(prevStage => {
            const updatedStage = { ...prevStage };
            // Set all stages' inView properties to false
            Object.keys(updatedStage).forEach(key => {
                updatedStage[key].inView = false;
            });
            // Set the desired stage's inView property to true
            updatedStage[nextStage].inView = true;
            return updatedStage;
        });
    }

    const anlagenNextButtonHandler = () => {
        var nextStage = "";
        var temp = {};

        if (anlageStage === "default") {
            nextStage = "anlage";
            if (data.street === "") temp.street = true;
            if (data.houseNumber === "") temp.houseNumber = true;
            if (data.anlageUse === "") temp.anlageUse = true;
            if (data.anlageUse === "Allgemeine Liegenschaftsteile" && data.anlageUseDesc === "") temp.anlageUseDesc = true;
            if ((data.anlageUse === "Wohnung" || data.anlageUse === "Gewerbe") && data.top === "") temp.top = true;
            if ((data.anlageUse === "Wohnung" || data.anlageUse === "Gewerbe") && user.x_bestandseinheitennummer_required && data.bestand === "") temp.bestand = true;
        }
        if (anlageStage === "anlage") {
            nextStage = "question";
            if (data.energyForm === "") temp.energyForm = true;
            if (data.zaehlerNumber1.length < 4) temp.zaehlerNumber1 = true;
            if (data.secondZaehler === true && data.zaehlerNumber2.length < 4) temp.zaehlerNumber2 = true;
            if (data.energyForm === "Gas") setData((prev) => ({ ...prev, smartmeter: false }));
        }
        if (anlageStage === "register_data") {
            nextStage = "summary";
            if (data.registerDate === "") temp.registerDate = true;
            if (data.useMtu === true && data.mtuName === "") temp.mtuName = true;
            if (data.useMtu === true && data.mtuDirect === true && data.mtuPaysOverTransfer === false && data.cardHolder === "") temp.cardHolder = true;
            if (data.useMtu === true && data.mtuDirect === true && data.mtuPaysOverTransfer === false && data.iban === "") temp.iban = true;
            if (data.useMtu === true && data.mtuDirect === true && data.mtuPaysOverTransfer === false && VALIDATOR.ibanValid(data.iban.replace(/\s+/g, '')) === false) temp.iban = true;
            if (data.smartmeter === false && new Date(data.registerDate) < dateLimit && data.zaehlerstand1 === "") temp.zaehlerstand1 = true;
            if (data.smartmeter === false && new Date(data.registerDate) < dateLimit && isNaN(data.zaehlerstand1)) temp.zaehlerstand1 = true;
            if (data.smartmeter === false && data.secondZaehler === true && new Date(data.registerDate) < dateLimit && data.zaehlerstand2 === "") temp.zaehlerstand2 = true;
            if (data.smartmeter === false && data.secondZaehler === true && new Date(data.registerDate) < dateLimit && isNaN(data.zaehlerstand2)) temp.zaehlerstand2 = true;
        }
        if (anlageStage === "summary") {
            nextStage = "default";
            var anlageTemp = {
                street: data.street,
                houseNumber: data.houseNumber,
                anlageUse: data.anlageUse,
                anlageUseDesc: data.anlageUseDesc,
                staircase: data.staircase,
                top: data.top,
                bestand: data.bestand,
                energyForm: data.energyForm,
                smartmeter: data.smartmeter,
                secondZaehler: data.secondZaehler,
                zaehlerNumber1: data.zaehlerNumber1,
                zaehlerNumber2: data.zaehlerNumber2,
                register: data.register,
                asLeerstand: data.asLeerstand,
                registerDate: data.registerDate,
                zaehlerstand1: data.zaehlerstand1,
                zaehlerstand2: data.zaehlerstand2,
                useMtu: data.useMtu,
                mtuName: data.mtuName,
                mtuDirect: data.mtuDirect,
                cardHolder: data.cardHolder,
                iban: data.iban,
                mtuPaysOverTransfer: data.mtuPaysOverTransfer,
            }
            setData((prev) => ({ ...prev, anlagen: [...prev.anlagen, anlageTemp] }));
            setData((prev) => ({
                ...prev,
                street: data.building_street,
                houseNumber: data.building_houseNumber,
                anlageUse: "",
                anlageUseDesc: "",
                staircase: "",
                top: "",
                bestand: "",
                energyForm: "",
                smartmeter: true,
                secondZaehler: false,
                zaehlerNumber1: "",
                zaehlerNumber2: "",
                register: false,
                asLeerstand: false,
                registerDate: "",
                zaehlerstand1: "",
                zaehlerstand2: "",
                useMtu: false,
                mtuName: "",
                mtuDirect: false,
                cardHolder: "",
                iban: "",
                mtuPaysOverTransfer: false,
            }))
            setShowAnlageAddForm(false);
        }

        if (Object.keys(temp).length > 0) {
            return setFieldsError(temp);
        }
        return setAnlageStage(nextStage);
    }


    const uidFieldHandler = (event) => {
        var value = event.target.value;
        setData((prev) => ({ ...prev, uid: value.toUpperCase() }));
    }

    // handler for iban field
    const ibanHandler = (event) => {
        const inputValue = event.target.value;

        // replace any characters that aren't digit or letter
        const formattedValue = inputValue.replace(/[^a-zA-Z0-9]/g, '');

        // group characters in 4 block
        const restFormatted = formattedValue.substring(0).replace(/(.{4})(?!$)/g, '$1 ');

        // set new value with uppercase
        setData((prev) => ({ ...prev, building_iban: restFormatted.toUpperCase() }));
    };

    // add file as to file list 
    const addToFileList = (file) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setData((prev) => ({ ...prev, vollmacht: ({ file_name: file.name, file: reader.result.split(",")[1] }) }));
        }
    }

    const deleteItemFromAnlageList = (zaehlerNumber) => {
        var tempList = data.anlagen.filter(a => a.zaehlerNumber1 !== zaehlerNumber);
        setData((prev) => ({ ...prev, anlagen: tempList }));
    }


    const sendDataHandler = () => {
        setSendingData(true);
        API.hw_BuildingsNew(data)
            .then(() => {
                setSendingData(false);
                nextBtnHandler();
            })
            .catch(() => {
                setSendingData(false);
            });
    }


    return (
        <>
            <Container>
                <Row>
                    <Col className="text-start">
                        <h3>Neue Liegenschaft</h3>
                        <p className="text-muted">Hier können Sie eine Liegenschaft und dazugehörige Anlagen hinzufügen</p>
                    </Col>
                </Row>
                <Row className="mt-3 justify-content-center">
                    <Col xl="10">
                        <Card style={{ borderRadius: "15px", minHeight: "200px", borderBottom: "6px solid #a2c13f" }} className="shadow-lg">
                            <Card.Body >
                                <ol className="stepper" hidden={stage.done.inView}>
                                    <li className={stage.name.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                        {stage.name.done ?
                                            <a href="#" className="link-energo" onClick={e => { e.preventDefault(); nextBtnHandler("name") }}>Name</a>
                                            :
                                            "Name"
                                        }
                                    </li>
                                    <li className={stage.address.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                        {stage.address.done ?
                                            <a href="#" className="link-energo" onClick={e => { e.preventDefault(); nextBtnHandler("address") }}>Adresse</a>
                                            :
                                            "Adresse"
                                        }
                                    </li>
                                    <li className={stage.abrechnung.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                        {stage.abrechnung.done ?
                                            <a href="#" className="link-energo" onClick={e => { e.preventDefault(); nextBtnHandler("abrechnung") }}>Abrechnung</a>
                                            :
                                            "Abrechnung"
                                        }
                                    </li>
                                    <li className={stage.anlagen.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                        {stage.anlagen.done ?
                                            <a href="#" className="link-energo" onClick={e => { e.preventDefault(); nextBtnHandler("anlagen") }}>Anlagen</a>
                                            :
                                            "Anlagen"
                                        }
                                    </li>
                                    <li className={stage.done.inView ? "active animate__animated animate__backInRight" : "animate__animated animate__bounceOutRight"}>
                                        {stage.done.done ?
                                            <a href="#" className="link-energo" onClick={e => { e.preventDefault(); nextBtnHandler("done") }}>Fertig</a>
                                            :
                                            "Fertig"
                                        }
                                    </li>
                                </ol>
                                <Row className="mt-3">
                                    {stage.name.inView ?
                                        <div id="name_div" className="animate__animated animate__fadeInDown">
                                            <Row className="justify-content-center">
                                                <Col xl="10">
                                                    <p className="text-energo">Name und interne Objektbezeichnung der Liegenschaft (z.B. Mustergasse 44, Musterstadt; 1234)</p>
                                                    <FloatingLabel label="Name">
                                                        <FormControl
                                                            value={data.building_name}
                                                            onChange={e => { setData((prev) => ({ ...prev, building_name: e.target.value, building_cardHolder: e.target.value })); setFieldsError({}) }}
                                                            isValid={data.building_name.length > 3}
                                                            isInvalid={fieldErrors.building_name}
                                                            placeholder="Name/Bezeichnung"
                                                        />
                                                    </FloatingLabel>
                                                    <FloatingLabel label="Interne Objektbezeichnung">
                                                        <FormControl
                                                            value={data.building_ident}
                                                            onChange={e => { setData((prev) => ({ ...prev, building_ident: e.target.value })); setFieldsError({}) }}
                                                            isValid={data.building_ident !== ""}
                                                            isInvalid={fieldErrors.building_ident}
                                                            className="mt-3"
                                                            placeholder="Name/Bezeichnung"
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                            </Row>
                                            <Row className="mt-3 justify-content-center">
                                                <Col xl="4" style={{display: "flex", alignItems: "center"}}>
                                                    <FloatingLabel label="Vorgang auswählen" style={{marginRight: 10}}>
                                                        <FormSelect
                                                            value={data.vorgang}
                                                            onChange={e => { setData((prev) => ({ ...prev, vorgang: e.target.value })); setFieldsError({}) }}
                                                            isValid={data.vorgang !== ""}
                                                            isInvalid={fieldErrors.vorgang}
                                                        >
                                                            <option value="Erstbezugsobjekt">Erstbezugsobjekt</option>
                                                            <option value="Bestand erfassen">Bestand erfassen</option>
                                                            <option value="Hausverwaltungswechsel">Hausverwaltungswechsel</option>
                                                        </FormSelect>
                                                    </FloatingLabel>
                                                    {tooltipsTrigger?
                                                        tooltips.find(t => t.code === 8001) !== undefined?
                                                            <EnergoTooltip text={tooltips.find(t => t.code === 8001).help_text} position="right" /> : null
                                                    :null}
                                                </Col>
                                                <Col xl="6">
                                                    <FloatingLabel label="Alte Hausverwaltung" hidden={data.vorgang !== "Hausverwaltungswechsel"}>
                                                        <FormControl
                                                            value={data.oldHw}
                                                            onChange={e => { setData((prev) => ({ ...prev, oldHw: e.target.value })); setFieldsError({}) }}
                                                            isValid={data.oldHw.length > 3}
                                                            isInvalid={fieldErrors.oldHw}
                                                            placeholder="Alte Hausverwaltung"
                                                        />
                                                    </FloatingLabel>
                                                </Col>
                                                <Col xl="12" className="text-end mt-3" >
                                                    <Button className="btn-energo" onClick={() => nextBtnHandler()}>Weiter</Button>
                                                </Col>
                                            </Row>
                                        </div> :
                                        stage.address.inView ?
                                            <div className="animate__animated animate__bounceInDown">
                                                <Row className="justify-content-center">
                                                    <Col xl="10">
                                                        <p className="text-energo">Adresse der Liegenschaft</p>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-center mt-3">
                                                    <Col xl="5">
                                                        <FloatingLabel label="Staat">
                                                            <FormSelect
                                                                value={data.country}
                                                                onChange={e => { setData((prev) => ({ ...prev, country: e.target.value })); setFieldsError({}) }}
                                                                isValid={data.country !== ""}
                                                                isInvalid={fieldErrors.country}
                                                            >
                                                                <option value="12">Österreich</option>
                                                                <option value="57">Deutschland</option>
                                                            </FormSelect>
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xl="5">
                                                        <FloatingLabel label="Bundesland">
                                                            <FormSelect
                                                                value={data.state}
                                                                onChange={e => { setData((prev) => ({ ...prev, state: e.target.value })); setFieldsError({}) }}
                                                                isValid={data.state !== ""}
                                                                isInvalid={fieldErrors.state}
                                                            >
                                                                <option value="1436">Burgenland</option>
                                                                <option value="1437">Kärnten</option>
                                                                <option value="1438">Niederösterreich</option>
                                                                <option value="1439">Oberösterreich</option>
                                                                <option value="1440">Salzburg</option>
                                                                <option value="1441">Steiermark</option>
                                                                <option value="1442">Tirol</option>
                                                                <option value="1443">Vorarlberg</option>
                                                                <option value="1444">Wien</option>
                                                            </FormSelect>
                                                        </FloatingLabel>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-center mt-3">
                                                    <Col xl="7">
                                                        <FloatingLabel label="Straße">
                                                            <FormControl
                                                                value={data.building_street}
                                                                onChange={e => { setData((prev) => ({ ...prev, building_street: e.target.value, street: e.target.value })); setFieldsError({}) }}
                                                                isValid={data.building_street.length > 3}
                                                                isInvalid={fieldErrors.building_street}
                                                                placeholder="Straße"
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xl="3">
                                                        <FloatingLabel label="Hausnummer">
                                                            <FormControl
                                                                value={data.building_houseNumber}
                                                                onChange={e => { setData((prev) => ({ ...prev, building_houseNumber: e.target.value, houseNumber: e.target.value })); setFieldsError({}) }}
                                                                isValid={data.building_houseNumber !== ""}
                                                                isInvalid={fieldErrors.building_houseNumber}
                                                                placeholder="Hausnummer"
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-center mt-3">
                                                    <Col xl="3">
                                                        <FloatingLabel label="PLZ">
                                                            <FormControl
                                                                value={data.zip}
                                                                onChange={e => { setData((prev) => ({ ...prev, zip: e.target.value })); setFieldsError({}) }}
                                                                isValid={((data.country === "12" && data.zip.length === 4) || (data.country === "57" && data.zip.length === 5)) && VALIDATOR.IsNumeric(data.zip)}
                                                                isInvalid={fieldErrors.zip}
                                                                placeholder="PLZ"
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                    <Col xl="7">
                                                        <FloatingLabel label="Ort">
                                                            <FormControl
                                                                value={data.city}
                                                                onChange={e => { setData((prev) => ({ ...prev, city: e.target.value })); setFieldsError({}) }}
                                                                isValid={data.city.length > 3}
                                                                isInvalid={fieldErrors.city}
                                                                placeholder="Ort"
                                                            />
                                                        </FloatingLabel>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-center mt-5 text-end">
                                                    <Col xl="12">
                                                        <Button onClick={() => backBtnHandler("name")} variant="warning" style={{ marginRight: "10px" }}>Zurück</Button>
                                                        <Button onClick={() => nextBtnHandler()} className="btn-energo">Weiter</Button>
                                                    </Col>
                                                </Row>
                                            </div> :
                                            stage.abrechnung.inView ?
                                                <div id="abrechnung_div" className="animate__animated animate__fadeInDownBig">
                                                    <Row className="justify-content-center align-items-center">
                                                        <Col xl="10">
                                                            <p className="text-energo">Zahlungsinformationen</p>
                                                        </Col>
                                                        <Col xl="5" hidden={data.noUid === true}>
                                                            <FloatingLabel label="UID-Nummer">
                                                                <FormControl
                                                                    value={data.uid}
                                                                    onChange={e => { uidFieldHandler(e); setFieldsError({}) }}
                                                                    isValid={VALIDATOR.vatValid(data.uid)}
                                                                    isInvalid={fieldErrors.uid}
                                                                    placeholder="UID-Nummer"
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                        <Col xl={data.noUid? "10":"5"} className="text-start">
                                                            <Form.Check
                                                                defaultChecked={data.noUid}
                                                                value={data.noUid}
                                                                onChange={e => setData((prev) => ({ ...prev, noUid: e.target.checked }))}
                                                                type="checkbox"
                                                                label="Keine UID-Nummer vorhanden"
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-3 justify-content-center">
                                                        <Col xl="5">
                                                            <FloatingLabel label="Kontoinhaber">
                                                                <FormControl
                                                                    value={data.building_cardHolder}
                                                                    onChange={e => { setData((prev) => ({ ...prev, building_cardHolder: e.target.value })); setFieldsError({}) }}
                                                                    isValid={data.building_cardHolder.length > 3}
                                                                    isInvalid={fieldErrors.building_cardHolder}
                                                                    placeholder="Kontoinhaber"
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                        <Col xl="5">
                                                            <FloatingLabel label="IBAN">
                                                                <FormControl
                                                                    value={data.building_iban}
                                                                    onChange={e => { ibanHandler(e); setFieldsError({}) }}
                                                                    isValid={VALIDATOR.ibanValid(data.building_iban.replace(/\s+/g, ''))}
                                                                    isInvalid={fieldErrors.building_iban}
                                                                    placeholder="IBAN"
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-5 justify-content-center align-items-center">
                                                        <Col xl="10">
                                                            <p className="text-energo">Verwaltungsinformationen</p>
                                                        </Col>
                                                        <Col xl="5">
                                                            <FloatingLabel label="Datum Poolbeitritt / Datum der Verwaltungsübernahme">
                                                                <FormControl
                                                                    value={data.poolStarts}
                                                                    onChange={e => { setData((prev) => ({ ...prev, poolStarts: e.target.value })); setFieldsError({}) }}
                                                                    isValid={data.poolStarts !== ""}
                                                                    isInvalid={fieldErrors.poolStarts}
                                                                    type="date"
                                                                    placeholder="Datum Poolbeitritt / Datum der Verwaltungsübernahme"
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                        <Col xl="5" className="text-center">
                                                            {
                                                                contactPerson !== null && contactPerson !== undefined? 
                                                                    <p className="text-energo">{contactPerson.name}</p> :
                                                                    <a 
                                                                        style={fieldErrors.hwContact ? {border: "1px solid red", padding: "8px"}: null}
                                                                        href="/kontakt/" 
                                                                        onClick={e => {e.preventDefault(); setContactPersonModal(true); setData((prev) => ({...prev, hwContact: contactPerson})) }} 
                                                                        className="link-energo">
                                                                            Kontakt bei Hausverwaltung auswählen
                                                                    </a>
                                                            }
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-5 justify-content-center align-items-center">
                                                        <Col xl={data.noVollmacht? "10":"5"}>
                                                            <Form.Check
                                                                defaultChecked={data.noVollmacht}
                                                                value={data.noVollmacht}
                                                                onChange={e => setData((prev) => ({ ...prev, noVollmacht: e.target.checked }))}
                                                                type="checkbox"
                                                                label="Es liegt noch keine Vollmacht vor. Diese wird später nachgereicht"
                                                            />
                                                        </Col>

                                                        <Col xl="5" className="text-center" hidden={data.noVollmacht === true} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                                            <input type="file" name="attachment" id="attachment" hidden onChange={e => addToFileList(e.target.files[0])} />
                                                            {data.vollmacht.file_name ?
                                                                <p className="text-energo">{data.vollmacht.file_name}</p>
                                                                :
                                                                <a
                                                                    style={fieldErrors.vollmacht ? { border: "1px solid red", padding: "8px", marginRight: 10 } : {marginRight: 10}}
                                                                    href="#"
                                                                    onClick={(e) => { e.preventDefault(); document.getElementById('attachment').click() }}
                                                                    className="link-energo"><MdAttachFile size={25}
                                                                    /> Verwaltungsvollmacht uploaden
                                                                </a>
                                                            }
                                                            {tooltipsTrigger?
                                                                tooltips.find(t => t.code === 8002) !== undefined?
                                                                    <EnergoTooltip text={tooltips.find(t => t.code === 8002).help_text} position="right" /> : null
                                                            :null}
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-5 justify-content-center text-end">
                                                        <Col xl="12">
                                                            <Button onClick={() => backBtnHandler("address")} variant="warning" style={{ marginRight: "10px" }}>Zurück</Button>
                                                            <Button onClick={() => nextBtnHandler()} className="btn-energo">Weiter</Button>
                                                        </Col>
                                                    </Row>
                                                </div> :
                                                stage.anlagen.inView ?
                                                    <div className="animate__animated animate__bounceInDown">
                                                        <Row className="mt-3 justify-content-center" hidden={showAnlageAddForm}>
                                                            <Col xl="10">
                                                                {data.anlagen && data.anlagen.length > 0 ?
                                                                    <Table hover>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Nr</th>
                                                                                <th>Anlagenverwendung</th>
                                                                                <th>Top</th>
                                                                                <th>Spez. Anlagenverwendung</th>
                                                                                <th>Energieform</th>
                                                                                <th>Anlage anmelden</th>
                                                                                <th></th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {data.anlagen.length === 0 ?
                                                                                <tr>
                                                                                    <td colSpan="7"><small>Noch keine Anlage hinzufügt</small></td>
                                                                                </tr>
                                                                                :
                                                                                data.anlagen.map((a, i) =>
                                                                                    <tr key={a.zaehlerNumber1}>
                                                                                        <td>{i + 1}</td>
                                                                                        <td>{a.anlageUse}</td>
                                                                                        <td>{a.top}</td>
                                                                                        <td>{a.anlageUseDesc}</td>
                                                                                        <td>{a.energyForm}</td>
                                                                                        <td>{a.register ? <FaCheck className="text-energo" /> : <HiXMark className="text-danger" />}</td>
                                                                                        <td><a onClick={e => {e.preventDefault(); deleteItemFromAnlageList(a.zaehlerNumber1) }} href="#"><RiDeleteBin5Fill size={20} className="text-danger" /></a></td>
                                                                                    </tr>
                                                                                )
                                                                            }
                                                                        </tbody>
                                                                    </Table>
                                                                :
                                                                    <p className="text-center">Geben Sie hier die Energieanlagen der neuen Liegenschaft ein.</p>
                                                                }
                                                            </Col>
                                                            <Col xl="10" className="text-center mt-3">
                                                                <Button onClick={() => setShowAnlageAddForm(true)} hidden={showAnlageAddForm} className="btn-energo" style={{ marginRight: "10px" }}>Anlagen hinzufügen</Button>
                                                            </Col>
                                                            <Col xl="12" style={{ marginTop: "200px" }} className="text-end">
                                                                {sendingData?
                                                                    <Spinner animation="border" className="text-energo" />
                                                                    :
                                                                    <>
                                                                        <Button onClick={() => backBtnHandler("abrechnung")} variant="warning" style={{ marginRight: "10px" }}>Zurück</Button>
                                                                        <Button onClick={() => sendDataHandler()} className="btn-energo">Anlagen hinzufügen abschließen</Button>
                                                                    </>
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <Row className="justify-content-center" hidden={showAnlageAddForm === false}>
                                                            <h5 className="text-energo mb-4">Anlageninformationen erfassen</h5>
                                                            <Col xl="10">
                                                                {
                                                                    anlageStage === "default" ?
                                                                        <div className="mt-5 text-end">
                                                                            <AnlageUseStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                                                                            <br />
                                                                            <Button onClick={() => setShowAnlageAddForm(false)} variant="warning" style={{ marginRight: "10px" }}>Abbrechen</Button>
                                                                            <Button className="btn-energo" onClick={() => anlagenNextButtonHandler()}>Weiter</Button>
                                                                        </div> :
                                                                        anlageStage === "anlage" ?
                                                                            <div>
                                                                                <AnlageDataStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                                                                                <br />
                                                                                <div className="text-end">
                                                                                    <Button onClick={() => setShowAnlageAddForm(false)} variant="warning" style={{ marginRight: "10px" }}>Abbrechen</Button>
                                                                                    <Button className="btn-energo" onClick={() => setAnlageStage('question')}>Weiter</Button>
                                                                                </div>
                                                                            </div> :
                                                                            anlageStage === "question" ?
                                                                                <QuestionRegisterStage setStage={setAnlageStage} setData={setData} /> :

                                                                                anlageStage === "register_data" ?
                                                                                    <div className="mt-5">
                                                                                        <RegisterStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                                                                                        <br />
                                                                                        <Button className="btn-energo" onClick={() => anlagenNextButtonHandler()}>Weiter</Button>
                                                                                    </div> :
                                                                                    anlageStage === "summary" ?
                                                                                        <div className="mt-5 text-start">
                                                                                            <SummaryStage data={data} setData={setData} errors={fieldErrors} setErrors={setFieldsError} />
                                                                                            <br />
                                                                                            <div className="text-end">
                                                                                                <Button onClick={() => setShowAnlageAddForm(false)} variant="warning" style={{ marginRight: "10px" }}>Abbrechen</Button>
                                                                                                <Button onClick={() => anlagenNextButtonHandler()} className="btn-energo">Hinzufügen</Button>
                                                                                            </div>
                                                                                        </div>
                                                                                        : null
                                                                }
                                                            </Col>
                                                        </Row>
                                                    </div> :
                                                    stage.done.inView ?
                                                        <Row className="justify-content-center">
                                                            <Col xl="10">
                                                                <div className="animate__animated animate__backInRight">
                                                                    <TbConfetti size={80} className="text-energo animate__animated animate__tada animate__delay-2s" />
                                                                </div>
                                                            </Col>
                                                            <Col xl="10">
                                                                <h3 className="mt-3">Fertig!</h3>
                                                                <p className="text-muted">Vielen Dank! Wir haben die Daten zur Liegenschaft erhalten und werden Sie in Kürze bearbeiten.</p>
                                                            </Col>
                                                            <Col xl="10" className="mt-3">
                                                                <a href="/hw/dashboard/" className="link-energo">Zum Dashboard</a>
                                                            </Col>
                                                        </Row> :
                                                        null
                                    }
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <ContactPersonModal show={contactPersonModal} setShow={setContactPersonModal} />
        </>
    )
}

export default NewBuildingPage;